import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { MainFuseDrawerService } from '@sbd-account-portal/app/modules/main-fuse-drawer/main-fuse-drawer.service';

export interface DrawerMenuItem {
  id: string;
  label: string;
  icon?: string;
  enabled?: boolean;
  visible?: boolean;
  action?: string | (() => void);
  permissions?: string[];
}

export interface DrawerBottomBarButton {
  id: string;
  label: string;
  color: 'primary' | 'accent' | 'warn' | '';
  action: string | (() => void);
  enabled?: boolean;
  visible?: boolean;
  permissions?: string[];
  icon?: string;
}

export interface DrawerConfig {
  menuItems?: DrawerMenuItem[];
  buttons?: DrawerBottomBarButton[];
  title?: string;
  subtitle?: string;
  context?: any;
}

export interface DrawerTemplate {
  buttons: DrawerBottomBarButton[];
}

/*Templates*/

export const createSoldQrMessagingBottomButtons = (component: any, quoteRequest: OpenQuoteRequestsItem): DrawerBottomBarButton[] => [
  {
    id: 'send_message',
    label: 'Send Message',
    color: 'primary',
    action: () => component.sendMessage(),
    enabled: true,
    visible: true,
  },
  {
    id: 'close',
    label: 'Close',
    color: '',
    action: () => component.close(),
    enabled: true,
    visible: true,
  },
];

export const createPurchasableQrBottomButtons = (component: any, quoteRequest: OpenQuoteRequestsItem): DrawerBottomBarButton[] => [
  {
    id: 'cancel',
    label: 'Cancel',
    color: '',
    action: () => component.closeDrawer(),
    enabled: true,
    visible: true,
  },
  {
    id: 'buy_now',
    label: 'Buy Now',
    color: 'primary',
    action: () => component.expressPurchaseQuoteRequest(quoteRequest),
    enabled: true,
    visible: true,
  },
];

export const createOpenQrMenuItems = (component: any): DrawerMenuItem[] => [
  {
    id: 'rider-request',
    label: 'Request a Change Rider',
    action: () => component.openNewDrawer('Rider'),
    enabled: component.currentOpenQRIsIssued(),
  },
  {
    id: 'send-message',
    label: 'Send Message',
    action: () => component.sendMessageFromDrawer(),
    enabled: component.currentOpenQRIsManaged(),
  },
  {
    id: 'request-change',
    label: 'Request a Change',
    action: () => component.sendMessageFromDrawerMakeAChange(),
    enabled: component.currentOpenQRCanRequestChange(),
  },
  {
    id: 'attach-file',
    label: 'Attach File',
    action: () => component.openFileUploader(),
    enabled: component.currentOpenQRIsPurchased(),
  },
  {
    id : 'decline-quote',
    label: 'Decline Quote',
    action: () => component.declineQuote(),
    enabled: component.currentOpenQRCanDecline(),
  },
  {
    id: 'add-alternative-address',
    label: 'Add Alternative Address',
    enabled: false,
  },
  {
    id: 'add-change-dba',
    label: 'Add or Change DBA',
    enabled: false,
  },
  {
    id: 'cancel-requests',
    label: 'Cancel Requests',
    enabled: false,
  },
];

function createButtonsForContext(
  context: 'OpenQR' | 'Rider',
  component: any,
  _mainFuseDrawerService: MainFuseDrawerService,
  quoteRequest: OpenQuoteRequestsItem = null,
): DrawerBottomBarButton[] {
  if (context === 'OpenQR') {
    if (_mainFuseDrawerService.currentOpenQRIsPurchasable())
      return createPurchasableQrBottomButtons(component, quoteRequest);

    if (_mainFuseDrawerService.currentOpenQRIsPurchased())
      return createSoldQrMessagingBottomButtons(component, quoteRequest);
  }
  return [];
}

export function createDrawerTemplate(
  context: 'OpenQR' | 'Rider',
  component: any,
  _mainFuseDrawerService: MainFuseDrawerService,
  quoteRequest: OpenQuoteRequestsItem,
): DrawerTemplate {
  const buttons = createButtonsForContext(context, component, _mainFuseDrawerService, quoteRequest);

  return { buttons };
}

